import { Injectable } from "@angular/core";

import { Quote } from "../quote.type";

// Hands a freshly created quote from the form to the resolver when the form swaps `quote/0` for the
// real url. Router state cannot carry it: the browser serializes state into the history entry, so a
// reload would deliver a plain object with no model behind it.
@Injectable({ providedIn: "root" })
export class QuoteHandoverService {
  private quote: Quote = null;

  public hand(quote: Quote): void {
    this.quote = quote;
  }

  public take(id: string): Quote {
    const quote = this.quote;
    this.quote = null;

    return quote && String(quote.getId()) === id ? quote : null;
  }
}
